// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PatientPodFamilyAccountMemberResponse } from './patient-pod-family-account-member-response';

/** See com.rev360.pms.api.controller.patient.pod.PatientPodFamilyMembersResponse */
/* istanbul ignore next */
@GandalfModel
export class PatientPodFamilyMembersResponse extends GandalfModelBase {

	@GandalfArray(PatientPodFamilyAccountMemberResponse)
	familyMembers!: PatientPodFamilyAccountMemberResponse[];

	@GandalfProperty({ designType: Boolean })
	hasAdditionalMembers!: boolean;

}
